import { Box, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const FooterSection = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderTop: '1px solid rgba(145, 158, 171, 0.12)',
  backdropFilter: 'blur(8px)',
  width: '100%',
  padding: theme.spacing(3, 0),
}));

const FooterLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  transition: 'color 0.2s ease-in-out',
  fontSize: '0.9rem',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

export const Footer = () => {
  return (
    <FooterSection component="footer">
      <Container maxWidth="lg">
        <Box 
          display="flex" 
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'center', sm: 'flex-start' }}
          gap={3}
        >
          <nav>
            <Box 
              component="ul"
              display="flex"
              gap={4}
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'center', sm: 'flex-start' }}
              sx={{
                listStyle: 'none',
                p: 0,
                m: 0,
                '& li': {
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  },
                }
              }}
            >
              <li><FooterLink href="/how-it-works">How It Works</FooterLink></li>
              <li><FooterLink href="/faqs">FAQs</FooterLink></li>
              <li><FooterLink href="/contact">Contact us</FooterLink></li>
            </Box>
          </nav>
          <FooterLink href="/terms">Terms & Conditions</FooterLink>
        </Box>
      </Container>
    </FooterSection>
  );
}; 